var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userIsAdmin)?_c('b-button',{staticClass:"offer-button",attrs:{"variant":_vm.notifications > 0 ? 'white' : 'primary',"size":"lg"},on:{"click":function($event){return _vm.showOffers()}}},[_c('strong',{},[_vm._v(" "+_vm._s(_vm.$t("offers"))+" "),(
          typeof _vm.notifications === 'number' &&
          _vm.notifications > 0 &&
          _vm.userIsAdmin
        )?_c('span',[_vm._v(" "+_vm._s(_vm.notifications)+" ")]):_vm._e()])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }